import * as React from "react";
import { forwardRef } from "react";
const SvgUpDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 23, viewBox: "0 0 16 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.94 10.7733L8 7.71998L11.06 10.7733L12 9.83331L8 5.83331L4 9.83331L4.94 10.7733Z", fill: "#8E8E8E" }), /* @__PURE__ */ React.createElement("path", { d: "M4.94 12.8933L8 15.9466L11.06 12.8933L12 13.8333L8 17.8333L4 13.8333L4.94 12.8933Z", fill: "#8E8E8E" }));
const ForwardRef = forwardRef(SvgUpDown);
export default ForwardRef;
